import type { Role } from '@/types/Role';

/**
 * Find a role's index in an array using 3-tier matching:
 * 1. By stable id/code
 * 2. By name + billingStructure
 * 3. By name only (last resort)
 */
export function findRoleIndex(roles: Role[], target: Role): number {
  const targetId = target.id ?? (target as Record<string, unknown>).code ?? null;

  // 1) Prefer matching by stable id or code
  if (targetId) {
    const idx = roles.findIndex(
      (r) => (r.id ?? (r as Record<string, unknown>).code) === targetId
    );
    if (idx !== -1) return idx;
  }

  // 2) Fallback: match by name + billingStructure
  const idx2 = roles.findIndex(
    (r) =>
      r.name.trim().toLowerCase() === target.name.trim().toLowerCase() &&
      r.billingStructure === target.billingStructure
  );
  if (idx2 !== -1) return idx2;

  // 3) Last resort: match by name only
  return roles.findIndex(
    (r) => r.name.trim().toLowerCase() === target.name.trim().toLowerCase()
  );
}
